// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"272":"def949245429f515","449":"75d5e8308b6332a2","531":"91b2cfb370b405fd","679":"4de40e1de524d2e4"}[chunkId] + ".js";
};